// extracted by mini-css-extract-plugin
export var contrastLow = "_46-1";
export var externalLink = "_46-2";
export var externalLinkIcon = "_46-3";
export var link = "_46-0";
export var linkLabel = "_46-4";